export enum TweakStatus {
    ERROR = "Error",
    WARNING = "Warning",
    NORMAL = "Normal"
}